import gql from "graphql-tag";

export const MY_TIME_APPROVE_REQUEST = gql`
  mutation approveMyTimeRequest($_id: String!, $message: String) {
    approveMyTimeRequest(_id: $_id, message: $message) {
      result
      message
    }
  }
`;
